import { render, staticRenderFns } from "./banner-available-resolution.vue?vue&type=template&id=01ac91fe"
import script from "./banner-available-resolution.vue?vue&type=script&lang=js"
export * from "./banner-available-resolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports